<div class="sb-live-scoreboard" [ngClass]="'background-' + match?.SportHandle">
  <div class="sb-live-scoreboard--container">
    <div class="sb-live-scoreboard--time">
      <h6 *ngIf="match?.SportHandle !== 'darts'" class="sb-live-scoreboard--subtitle color-light">
        {{ matchPeriod }}<span *ngIf="matchTime"> - {{ matchTime }}</span>
      </h6>
    </div>
    <div class="sb-live-scoreboard--score">
      <div class="sb-live-scoreboard--score-left">
        <h6 class="sb-live-scoreboard--title color-light">
          {{ (match?.ParticipantHome === null || match?.ParticipantHome === undefined) ? 'null' : (match?.ParticipantHome | sportsTitleCase) }}
        </h6>
      </div>
      <div class="sb-live-scoreboard--score-badge">
        <p class="sb-live-scoreboard--score-badge-left sb-live-scoreboard--number color-light">
          {{ match?.ResultHome }}
        </p>
        <span class="sb-live-scoreboard--score-badge-center color-light">:</span>
        <p class="sb-live-scoreboard--score-badge-right sb-live-scoreboard--number color-light">
          {{ match?.ResultAway }}
        </p>
      </div>
      <div class="sb-live-scoreboard--score-right">
        <h6 class="sb-live-scoreboard--title color-light">
          {{ (match?.ParticipantAway === null || match?.ParticipantAway === undefined) ? 'null' : (match?.ParticipantAway | sportsTitleCase) }}
        </h6>
      </div>
    </div>
    <div class="sb-live-scoreboard--info"></div>
  </div>
</div>
